import type { EmailDraftT } from 'lib-shared-legacy-types';

import type { EmailDraftV2 } from 'apis/userStorage';

export const convertLocalDraftToV2 = (draft: EmailDraftT): EmailDraftV2 => {
  const toEmails =
    draft.toUser
      ?.filter((u) => u.user.email)
      .map((u) => ({ email: u.user.email!, name: u.user.name ?? undefined })) ??
    [];

  return {
    timestamp: draft.timestamp,
    fromEmail: draft.fromEmails ? [draft.fromEmails] : null,
    toEmail: toEmails.length > 0 ? [toEmails[0]] : [{ email: '' }],
    cc:
      draft.cc
        ?.filter((u) => u.user.email)
        .map((u) => ({
          email: u.user.email!,
          name: u.user.name ?? undefined,
        })) ?? [],
    bcc:
      draft.bcc
        ?.filter((u) => u.user.email)
        .map((u) => ({
          email: u.user.email!,
          name: u.user.name ?? undefined,
        })) ?? [],
    subject: draft.subject ?? '',
    body: draft.message ?? '',
    attachments_v2: (draft.attachments ?? [])
      .filter(
        (a): a is { name: string; relative_uri: string } =>
          typeof a?.name === 'string' && typeof a?.relative_uri === 'string',
      )
      .map((a) => ({
        prettyName: a.name,
        url: a.relative_uri,
        absoluteUri: '',
        size: 0,
      })),
    offerInQueue: false,
    internalNote: draft.internalNote ?? '',
    queueId: draft.queue ? [draft.queue.id] : null,
    tags: draft.tags ?? [],
    offer: draft.offer ?? false,
    linkType: draft.linkConversationType ?? null,
    parentConversation: draft.parentConversation ?? null,
    customAttributes: draft.customAttributes ?? {},
    customAttributesOpen: draft.customAttributesOpen ?? false,
    satisfactionLanguage: draft.satisfactionLanguage ?? null,
    cancelledSatisfaction: draft.cancelledSatisfaction ?? false,
  };
};
